import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=4b6248dd&"
import script from "./sales.vue?vue&type=script&lang=ts&"
export * from "./sales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports